<div fxLayout="row">
    <div fxFlex="35" style="margin-right: 16px;">
        <exercise-selection-list [exercises]="exercises" [loading]="loading" (exerciseSelected)="selectExercise($event)"></exercise-selection-list>
    </div>
    <div fxFlex>
        <exercise-editor [exercise]="selectedExercise" [exercises]="exercises" [categories]="categories"></exercise-editor>
    </div>
</div>
<ngx-guided-tour></ngx-guided-tour>